import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import RotatingSolutions from './components/RotatingSolutions';
import Solutions from './components/Solutions';
import Features from './components/Features';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ITADPage from './pages/ITADPage';
import ExcessiveInventoryPage from './pages/ExcessReturnsPage';
import StoreClosingPage from './pages/StoreClosingPage';
import DonationsPage from './pages/DonationsPage';
import CustomerReturnsPage from './pages/CustomerReturnsPage';
import AbandonedFreightPage from './pages/AbandonedFreightPage';
import NonprofitPage from './pages/NonprofitPage';
import ThreePLDistributorsPage from './pages/ThreePLDistributorsPage';
import EnterprisePage from './pages/EnterprisePage';
import RetailEcommercePage from './pages/RetailEcommercePage';
import ManufacturingPage from './pages/ManufacturingPage';
import SmallBusinessPage from './pages/SmallBusinessPage';
import FAQsPage from './pages/FAQsPage';
import ContactPage from './pages/ContactPage';
import WhoWeServePage from './pages/WhoWeServePage';
import './App.css';

const Layout = () => (
  <div className="App">
    <Header />
    <Outlet />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route
            index
            element={
              <HomePage
                hero={<Hero />}
                rotating={<RotatingSolutions />}
                solutions={<Solutions />}
                features={<Features />}
              />
            }
          />
          <Route path="services" element={<ServicesPage />} />
          <Route path="faqs" element={<FAQsPage />} />
          <Route path="services/abandoned-freight" element={<AbandonedFreightPage />} />
          <Route path="services/store-closing" element={<StoreClosingPage />} />
          <Route path="services/customer-returns" element={<CustomerReturnsPage />} />
          <Route path="services/itad" element={<ITADPage />} />
          <Route path="services/donations" element={<DonationsPage />} />
          <Route path="services/excessive-inventory" element={<ExcessiveInventoryPage />} />
          <Route path="who-we-serve" element={<WhoWeServePage />} />
          <Route path="who-we-serve/3pl-distributors" element={<ThreePLDistributorsPage />} />
          <Route path="who-we-serve/enterprise" element={<EnterprisePage />} />
          <Route path="who-we-serve/nonprofit" element={<NonprofitPage />} />
          <Route path="who-we-serve/retail-ecommerce" element={<RetailEcommercePage />} />
          <Route path="who-we-serve/manufacturing" element={<ManufacturingPage />} />
          <Route path="who-we-serve/small-business" element={<SmallBusinessPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
